// SPECIALIZED TELECOM - GLOBAL ACH INTEGRATION
// Automatically adds ACH payment options to cart pages

(function() {
    'use strict';
    
    console.log('🏦 Specialized Telecom ACH Integration Loading...');
    
    // Configuration
    const CONFIG = {
        enabled: true,
        cartSelectors: ['.cart', '#cart', '.template-cart', '[class*="cart"]', 'main'],
        debug: false
    };
    
    // Check if we're on a cart page
    function isCartPage() {
        return window.location.pathname.includes('/cart') || 
               document.body.classList.contains('template-cart') ||
               document.querySelector('.cart') !== null;
    }
    
    // Create ACH payment banner
    function createACHBanner() {
        const cartTotal = window.Shopify?.cart?.total_price || 0;
        const cartCount = window.Shopify?.cart?.item_count || 0;
        
        // Don't show if cart is empty
        if (cartCount === 0) return null;
        
        const totalDollars = (cartTotal / 100).toFixed(2);
        const achFee = (cartTotal * 0.008 / 100).toFixed(2);
        const cardFee = (cartTotal * 0.029 / 100).toFixed(2);
        const savings = Math.max(0, (cartTotal * 0.021 / 100)).toFixed(2);
        
        const banner = document.createElement('div');
        banner.id = 'specialized-ach-banner';
        banner.style.cssText = `
            margin: 20px auto;
            max-width: 600px;
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
        `;
        
        banner.innerHTML = `
            <div style="
                background: linear-gradient(135deg, #00d924, #00b81f);
                color: white;
                padding: 25px;
                border-radius: 12px;
                text-align: center;
                box-shadow: 0 4px 15px rgba(0, 217, 36, 0.2);
                position: relative;
                overflow: hidden;
            ">
                <div style="font-size: 32px; margin-bottom: 15px;">🏦</div>
                
                <h2 style="margin: 0 0 10px 0; font-size: 22px; font-weight: bold; line-height: 1.2;">
                    ACH Bank Transfer Available
                </h2>
                
                <p style="margin: 0 0 20px 0; font-size: 16px; opacity: 0.95; line-height: 1.4;">
                    Professional payment option for business customers<br>
                    <strong>Save money with secure bank transfers</strong>
                </p>
                
                ${cartTotal > 0 ? `
                <div style="
                    background: rgba(255, 255, 255, 0.2);
                    padding: 15px;
                    border-radius: 8px;
                    margin: 20px 0;
                    text-align: left;
                    display: inline-block;
                    min-width: 280px;
                ">
                    <div style="text-align: center; font-weight: bold; margin-bottom: 10px; font-size: 16px;">
                        Your Cart: $${totalDollars}
                    </div>
                    <div style="display: flex; justify-content: space-between; margin-bottom: 8px; font-size: 14px;">
                        <span>🏦 ACH Fee:</span>
                        <span>~$${achFee}</span>
                    </div>
                    <div style="display: flex; justify-content: space-between; margin-bottom: 8px; font-size: 14px;">
                        <span>💳 Card Fee:</span>
                        <span>~$${cardFee}</span>
                    </div>
                    <div style="
                        display: flex; 
                        justify-content: space-between; 
                        font-weight: bold; 
                        color: #ffff00; 
                        border-top: 1px solid rgba(255,255,255,0.3); 
                        padding-top: 8px; 
                        margin-top: 8px;
                    ">
                        <span>💰 You Save:</span>
                        <span>$${savings}</span>
                    </div>
                </div>
                ` : ''}
                
                <div style="margin-top: 20px;">
                    <a href="mailto:orders@specializedtelecom.com?subject=ACH Payment Request - $${totalDollars}&body=I would like to pay via ACH bank transfer for my cart total of $${totalDollars}.%0A%0APlease send me the ACH payment instructions.%0A%0AThank you!" 
                       style="
                           background: white;
                           color: #00d924;
                           padding: 15px 30px;
                           border-radius: 8px;
                           text-decoration: none;
                           font-weight: bold;
                           font-size: 16px;
                           display: inline-block;
                           transition: all 0.3s ease;
                           box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                       "
                       onmouseover="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 4px 12px rgba(0,0,0,0.15)'"
                       onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='0 2px 8px rgba(0,0,0,0.1)'">
                        📧 Request ACH Payment
                    </a>
                </div>
                
                <div style="margin-top: 15px; font-size: 13px; opacity: 0.85; line-height: 1.3;">
                    Professional ACH processing available for all order amounts<br>
                    Secure • Fast • Business-Preferred Payment Method
                </div>
            </div>
        `;
        
        return banner;
    }
    
    // Insert ACH banner into cart page
    function insertACHBanner() {
        // Remove existing banner if present
        const existing = document.getElementById('specialized-ach-banner');
        if (existing) existing.remove();
        
        // Create new banner
        const banner = createACHBanner();
        if (!banner) return false;
        
        // Find best insertion point
        for (const selector of CONFIG.cartSelectors) {
            const container = document.querySelector(selector);
            if (container) {
                // Insert at the beginning of the container
                container.insertBefore(banner, container.firstChild);
                console.log('✅ ACH banner inserted into:', selector);
                return true;
            }
        }
        
        // Fallback: insert into body
        document.body.insertBefore(banner, document.body.firstChild);
        console.log('✅ ACH banner inserted into body (fallback)');
        return true;
    }
    
    // Initialize ACH integration
    function initializeACH() {
        if (!CONFIG.enabled) return;
        
        if (isCartPage()) {
            console.log('🏦 Cart page detected, adding ACH banner...');
            insertACHBanner();
            
            // Monitor for cart updates
            if (typeof MutationObserver !== 'undefined') {
                const observer = new MutationObserver(function(mutations) {
                    mutations.forEach(function(mutation) {
                        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                            // Delay to let cart update complete
                            setTimeout(insertACHBanner, 500);
                        }
                    });
                });
                
                const cartContainer = document.querySelector('.cart') || document.body;
                observer.observe(cartContainer, { childList: true, subtree: true });
            }
        } else {
            console.log('ℹ️ Not a cart page, ACH integration skipped');
        }
    }
    
    // Start when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeACH);
    } else {
        initializeACH();
    }
    
    // Export for debugging
    window.SpecializedTelecomACH = {
        init: initializeACH,
        createBanner: createACHBanner,
        isCartPage: isCartPage,
        config: CONFIG
    };
    
    console.log('✅ Specialized Telecom ACH Integration Loaded');
})();
